<div class="warehouse-home">
  <div class="warehouse-home__content">
    <div class="warehouse-home__header">
      <div>
        <h1 class="page-title">Warehouses</h1>
        <p class="page-subtitle">Manage warehouses and their address details.</p>
      </div>
    </div>

    <app-table
      [data]="warehouseState.data()"
      [columns]="warehouseColumns"
      [config]="warehouseConfig"
      [pagination]="warehousePagination"
      (sortChange)="onSortChange($event)"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
      (actionClick)="onActionClick($event)"
      (searchChange)="onSearchChange($event)"
      (dateRangeChange)="onDateRangeChange($event)"></app-table>
  </div>
</div>
